import { render, staticRenderFns } from "./IconDislike.vue?vue&type=template&id=69e01b53&scoped=true"
import script from "./IconDislike.vue?vue&type=script&lang=js"
export * from "./IconDislike.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69e01b53",
  null
  
)

export default component.exports